import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import cyclesReducer from './slices/cyclesSlice';
import usersReducer from './slices/usersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cycles: cyclesReducer,
    users: usersReducer,
  },
});
